// extracted by mini-css-extract-plugin
export default {"test-form":"EMXa52tHMq","testForm":"EMXa52tHMq"};